import { useCallback, useEffect, useState } from 'react';

import api from '../api';
import { SCHEDULED_EXPORTS_LIMIT } from '../configs/constants';

function useScheduledExportsCount() {
  const [isScheduledCountLoaded, setScheduledCountLoaded] = useState(false);
  const [scheduledExportsCount, setScheduledExportsCount] = useState(SCHEDULED_EXPORTS_LIMIT);

  const fetchScheduledExportsCount = useCallback(() => {
    api
      .getScheduledExportsCount()
      .then(({ data }) => {
        setScheduledExportsCount(data.scheduled_exports_count);
        setScheduledCountLoaded(true);
      })
      .catch(() => {
        setScheduledExportsCount(SCHEDULED_EXPORTS_LIMIT);
      });
  }, []);

  useEffect(() => {
    fetchScheduledExportsCount();
  }, [fetchScheduledExportsCount]);

  return {
    scheduledExportsCount,
    scheduleLimitReached: scheduledExportsCount >= SCHEDULED_EXPORTS_LIMIT,
    isScheduledCountLoaded,
    refetchScheduledExportsCount: fetchScheduledExportsCount,
  };
}

export default useScheduledExportsCount;
